const SupplierInfoProps = {
	//0 机构供应商  1 个人供应商 （查导游资源表）
	supplierType: {
		type: Number,
		default: 0
	}
}

export default SupplierInfoProps